import { useQuery } from "react-query";
import { getDropoffRecords } from "../../api/ship";
import { Button, Table } from "antd";

const columns = [
  {
    title: 'Tracking Number',
    dataIndex: 'trackingNumber',
    key: 'trackingNumber',
  },
  {
    title: 'Order date',
    dataIndex: 'createdAt',
    render: (value) => (
        <p className=''>{new Date(value).toLocaleDateString()}</p>
    )
  },
  {
    title: 'Customer',
    render: (_, values) => (
        <p className='capitalize'>{values?.customerId?.firstName} {values?.customerId?.lastName}</p>
    )
  },
  {
    title: 'Courier',
    dataIndex: 'courier',
    render: (value) => (
        <p>{value}</p>
    )
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (value) => (
        <p>{value}</p>
    )
  },
  {
    title: 'Has Paid',
    dataIndex: 'paid',
    render: (value) => (
        <p>{value ? "Yes" : "No"}</p>
    )
  },
  {
    title: 'Action',
    render: (_, values) => (
        <Button type='primary' onClick={() => window.location.href = `/shipping/drop-off/${values._id}`}>View</Button>
    )
  },
];

const DropoffTable = () => {
  const { data: records, isLoading } = useQuery("dropoff-records", getDropoffRecords);

  return (
    <div>
      <Table loading={isLoading} dataSource={records?.dropOffs || []} columns={columns} />
    </div>
  )
}

export default DropoffTable
